import { uuid4 } from "@helpers/crypto/crypto";
import { bindable } from "aurelia";
import ProgressBar from 'progressbar.js';

export class ProgressBarComponent {
  @bindable barHeight: string;

  private barId: string = uuid4();
  private bar: ProgressBar.Line

  attached() {
    const container = document.getElementById(this.barId);

    this.bar = new ProgressBar.Line(container, {
      svgStyle: { width: '100%', height: '100%' }, // Mantém responsivo
      strokeWidth: 1.5,
      trailWidth: 1.5,
      easing: 'easeInOut',
      duration: 1400,
      color: '#0079FF',
      trailColor: '#B0D5FD',
    });

    this.bar.set(0);
  }

  public getProgress() {
    return this.bar?.value();
  }

  public setProgress(progress: number) {
    this.bar.animate(progress, {
      easing: 'easeInOut',
    });
  }

}